import axios from "axios";
import React, { useState } from "react";
import { createContext } from "react";
import { VARIABLES } from "../Constant";

export const CandidateJobContext = createContext(null);

function CandidateJobProvider({ children }) {
  const [candidateJob, setCandidateJob] = useState([]);
  const [dashboardLoading, setDashboardLoading] = useState(false);


  const getCandidateJobData = async (candidate_id) => {
    setDashboardLoading(true);
    try {
      const res = await axios.get(
        VARIABLES.url + `/api/candidatejob/?candidate_job=${candidate_id}&send_from=career`
      ); //CHECK API
      setCandidateJob(res.data);
      setDashboardLoading(false);
    } catch (error) {
      setDashboardLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <CandidateJobContext.Provider
        value={{ candidateJob, dashboardLoading, getCandidateJobData }}
      >
        {children}
      </CandidateJobContext.Provider>
    </div>
  );
}

export default CandidateJobProvider;
